import { LoadingStatus } from 'models/LoadingStatus';

interface OwnState {
  validInstallations: string[];
  loadingStatus: LoadingStatus;
}

export const initialState: OwnState = {
  validInstallations: [],
  loadingStatus: LoadingStatus.Idle
};

export type Action =
  | { type: 'fetchValidInstallationIds' }
  | { type: 'fetchValidInstallationIdsSuccess'; installationIds: string[] }
  | { type: 'fetchValidInstallationIdsError' };

export const reducer = (state: OwnState, action: Action): OwnState => {
  switch (action.type) {
    case 'fetchValidInstallationIds':
      return {
        ...state,
        validInstallations: [],
        loadingStatus: LoadingStatus.Fetching
      };
    case 'fetchValidInstallationIdsSuccess':
      return {
        ...state,
        loadingStatus: LoadingStatus.Completed,
        validInstallations: action.installationIds
      };
    case 'fetchValidInstallationIdsError':
      return {
        ...state,
        loadingStatus: LoadingStatus.Error,
        validInstallations: []
      };
    default:
      return state;
  }
};
